import { getAuthToken, refreshAuthToken } from "auth/authToken";
import { MainContent } from "components/Layout/components/Content";
import { MasterLayout } from "components/Layout/components/MasterLayout";
import { SideBar } from "components/Layout/components/SideBar";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { Header, HeaderProps } from "../Layout/components/Header/Header";

type DummyContainerType = {
    headerProps: HeaderProps;
    note: string;
};

export const DummyContainer = ({ headerProps, note }: DummyContainerType) => {
    const navigate = useNavigate();

    const refreshToken = () =>
        refreshAuthToken().catch((e) => {
            // eslint-disable-next-line no-console
            console.error("Auth error", e);
            navigate("/auth");
        });

    useCallback(refreshToken, [navigate]);

    const authToken = getAuthToken();

    return (
        <MasterLayout>
            <Header appTitle={headerProps.appTitle} username={`${headerProps.username} @ ${note}`} userProfile={headerProps.userProfile} />
            <SideBar>menu</SideBar>
            <MainContent id="pageContent">
                authToken = {authToken}
                <h1>{note}</h1>
            </MainContent>
        </MasterLayout>
    );
};
